import { UserContentLayout } from '../../components/Layouts/UserContentLayout';
import { QRCodeSVG } from 'qrcode.react';
import { Heading, Flex } from '@chakra-ui/react';
import { useStoreContext } from '../../hooks/useStore';
import { useTranslation } from 'react-i18next';

const UserQrCode = () => {
  const { t } = useTranslation();
  const { store } = useStoreContext();
  const { code } = store?.user || {};

  return (
    <UserContentLayout caption={`${t('qr.code.caption')}`}>
      <Heading fontSize='xl' mt={{ base: 6, lg: 12 }}>
        {t('qr.code.description')}
      </Heading>

      <Flex justifyContent={{ base: 'center', lg: 'flex-start' }} pt={8}>
        {code ? (
          <QRCodeSVG value={code} fgColor='var(--chakra-colors-brand-cyan)' width='300px' height='300px' />
        ) : null}
      </Flex>
    </UserContentLayout>
  );
};

export default UserQrCode;
